
<template>
	<div class='inventory'>
		<el-form :model="form" :rules="form.rules" ref="form" :disabled="readonly">
			<div v-if="parentCodeType == $root.gc_category">
				<div>
					<div v-if="operationEnable">
						<el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData1">
							<i class="iconfont iconjiahaoyou"></i> 添加
						</el-button>
					</div>
					<el-table border key="tableData1" :max-height="maxHeight" :data="form.tableData1" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
						<el-table-column label="序号" type="index" fixed="left" width="100px">
							<template slot-scope="scope">
								<el-form-item>
									{{ scope.$index + 1 }}
								</el-form-item>
							</template>
						</el-table-column>
						<el-table-column label="报价类型" width="140px" fixed>
							<template slot-scope="scope">
								<span v-if="scope.row.quotationType == '2'">不计入合价</span>
								<span v-else>计入合价</span>
							</template>
						</el-table-column>
						<el-table-column label="标段" fixed width="140px" v-if="pageType != 'buyDemand' && type != 2">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.segmentsNumber&&!basicInfoDisable}">
									<el-select :disabled="segmentDisable || !scope.row.editable" size="mini" class="minWidth" v-model.trim="scope.row.segmentsNumber" placeholder="请选择">
										<el-option :key="1" :label="1" :value="1">
										</el-option>
										<el-option :key="2" :label="2" :value="2">
										</el-option>
									</el-select>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="分部分项名称" width="140px" fixed="left">
							<template slot-scope="scope">
								<div :class="{input_box:true}">
									<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.subitemName">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="工程项名称" width="140px" fixed="left">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.matterName&&!basicInfoDisable}">
									<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.matterName">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="工作/工艺内容描述/规格型号参数" width="140px" fixed="left">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.matterRequired&&!basicInfoDisable}">
									<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.matterRequired">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="投标推荐品牌" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.recommendBrand&&!basicInfoDisable}">
									<input type="text" class="input_block" :readonly="basicInfoDisable" size="mini" v-model.trim="scope.row.recommendBrand">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="投标品牌" width="140px">
							<template slot-scope="scope">
                                <div :class="{input_box:true,error_box:!scope.row.brandName&&!priceDisable}">
									<input type="text" class="input_block" :readonly="priceDisable" size="mini" v-model="scope.row.brandName">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="单位" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.unitName&&!basicInfoDisable}">
									<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.unitName">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="数量" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.quantities&&scope.row.quantities!==0&&!basicInfoDisable}">
									<input type="text" class="input_block" :readonly="basicInfoDisable" @blur="numberChange(scope.row,$event,'quantities')" :oninput="$root.numberFilter2" size="mini" v-model.trim="scope.row.quantities" @input="autoCompute(scope.row)">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="不含税综合单价（元）" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true}">
									<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'unitAmountExclTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.unitAmountExclTax" @input="autoCompute(scope.row)">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="税率（%）" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.taxRatio&&scope.row.taxRatio!==0&&!taxDisable}">
									<el-select :disabled="taxDisable" size="mini" class="minWidth" v-model.trim="scope.row.taxRatio" placeholder="请选择">
                    <el-option v-for="item in taxList" :key="item.id" :label="item.dictLabel" :value="item.dictValue"></el-option>
                  </el-select>
									<!-- <input type="text" class="input_block" @blur="numberChange(scope.row,$event,'taxRatio')" :oninput="$root.numberFilter" :readonly="taxDisable" v-model.trim="scope.row.taxRatio" @input="autoCompute(scope.row)"> -->
								</div>
							</template>
						</el-table-column>
						<el-table-column label="含税综合单价（元）" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.unitAmountWithTax&&scope.row.unitAmountWithTax!==0&&!priceDisable}">
									<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'unitAmountWithTax')" :oninput="$root.numberFilter6" v-model.trim="scope.row.unitAmountWithTax" @input="autoCompute(scope.row)" :readonly="priceDisable">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="不含税合价（元）" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true}">
									<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'amountExclTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.amountExclTax" @input="autoCompute(scope.row)">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="含税合价（元）" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true}">
									<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'amountWithTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.amountWithTax" @input="autoCompute(scope.row)">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="备注" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true}">
									<input type="text" class="input_block" :readonly="priceDisable" v-model.trim="scope.row.remarks">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
							<template slot-scope="scope">
								<el-button type="text" v-if="(scope.$index != 0 && scope.row.editable) || !validateFlag" size="mini" @click="del(scope.$index, 1)">
									<span style="color: #91002c">删除</span>
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div v-else-if="parentCodeType == $root.wzsb_category">
				<div v-if="operationEnable">
					<el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData3">
						<i class="iconfont iconjiahaoyou"></i> 添加
					</el-button>
				</div>
				<el-table :max-height="maxHeight" :highlight-current-row="false" border key="tableData3" :data="form.tableData3" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
					<el-table-column label="序号" type="index" fixed="left" width="100px">
						<template slot-scope="scope">
							<el-form-item>
								{{ scope.$index + 1 }}
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="报价类型" width="140px" fixed>
						<template slot-scope="scope">
							<span v-if="scope.row.quotationType == '2'">不计入合价</span>
							<span v-else>计入合价</span>
						</template>
					</el-table-column>
					<el-table-column label="标段" fixed width="140px" v-if="pageType != 'buyDemand' && type != 2">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.segmentsNumber&&!segmentDisable}">
								<el-select :disabled="segmentDisable || !scope.row.editable" size="mini" class="minWidth" v-model.trim="scope.row.segmentsNumber" placeholder="请选择">
									<el-option :key="1" :label="1" :value="1">
									</el-option>
									<el-option :key="2" :label="2" :value="2">
									</el-option>
								</el-select>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="招标事项" width="140px" fixed="left">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.matterName&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.matterName">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="招标需求内容描述/材质工艺等要求/规格型号" width="140px" fixed="left">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.matterRequired&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.matterRequired">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="投标推荐品牌" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.recommendBrand&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.recommendBrand">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="投标品牌" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.brandName&&!priceDisable}">
                                <input type="text" class="input_block" :readonly="priceDisable" size="mini" v-model="scope.row.brandName">
                            </div>
						</template>
					</el-table-column>
					<el-table-column label="数量" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.quantities&&scope.row.quantities!==0&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.quantities" :oninput="$root.numberFilter2">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="单位" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.unitName&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.unitName">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="不含税单价（元）" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'unitAmountExclTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.unitAmountExclTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="税率（%）" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.taxRatio&&scope.row.taxRatio!==0&&!taxDisable}">
                <el-select :disabled="taxDisable" size="mini" class="minWidth" v-model.trim="scope.row.taxRatio" placeholder="请选择">
                  <el-option v-for="item in taxList" :key="item.id" :label="item.dictLabel" :value="item.dictValue"></el-option>
                </el-select>
								<!-- <input type="text" class="input_block" @blur="numberChange(scope.row,$event,'taxRatio')" :oninput="$root.numberFilter" :readonly="taxDisable" v-model.trim="scope.row.taxRatio" @input="autoCompute(scope.row)"> -->
							</div>
						</template>
					</el-table-column>
					<el-table-column label="含税单价（元）" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.unitAmountWithTax&&scope.row.unitAmountWithTax!==0&&!priceDisable}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'unitAmountWithTax')" :readonly="priceDisable"
								:oninput="$root.numberFilter6" v-model.trim="scope.row.unitAmountWithTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="不含税合价（元）" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'amountExclTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.amountExclTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="含税合价（元）" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'amountWithTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.amountWithTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="备注" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true}">
								<input type="text" class="input_block" :readonly="priceDisable" v-model.trim="scope.row.remarks">
							</div>
						</template>
					</el-table-column>

					<el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
						<template slot-scope="scope">
							<el-button type="text" v-if="(scope.$index != 0 && scope.row.editable) || !validateFlag" size="mini" @click="del(scope.$index, 3)">
								<span style="color: #91002c">删除</span>
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-else-if="parentCodeType == $root.yxtg_category">
				<div v-if="operationEnable">
					<el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData4">
						<i class="iconfont iconjiahaoyou"></i> 添加
					</el-button>
				</div>
				<el-table border key="tableData4" :max-height="maxHeight" :data="form.tableData4" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
					<el-table-column label="序号" type="index" fixed="left" width="100px">
						<template slot-scope="scope">
							<el-form-item>
								{{ scope.$index + 1 }}
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="报价类型" width="140px" fixed>
						<template slot-scope="scope">
							<span v-if="scope.row.quotationType == '2'">不计入合价</span>
							<span v-else>计入合价</span>
						</template>
					</el-table-column>
					<el-table-column label="标段" fixed width="140px" v-if="pageType != 'buyDemand' && type != 2">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.segmentsNumber&&!segmentDisable}">
								<el-select :disabled="segmentDisable || !scope.row.editable" size="mini" class="minWidth" v-model.trim="scope.row.segmentsNumber" placeholder="请选择">
									<el-option :key="1" :label="1" :value="1">
									</el-option>
									<el-option :key="2" :label="2" :value="2">
									</el-option>
								</el-select>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="招标内容/需求" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.matterRequired&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.matterRequired">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="区域/位置" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.areaLocations&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.areaLocations">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="制作工艺（工艺及材料描述详细）/事项内容要求描述" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.matterDesc&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.matterDesc">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="规格尺寸" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.speciificationSize&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.speciificationSize">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="数量" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.quantities&&scope.row.quantities!==0&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.quantities" :oninput="$root.numberFilter2">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="天数" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.dayAmount&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.dayAmount">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="单位" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.unitName&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.unitName">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="不含税单价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'unitAmountExclTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.unitAmountExclTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="税率（%）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.taxRatio&&scope.row.taxRatio!==0&&!taxDisable}">
                <el-select :disabled="taxDisable" size="mini" class="minWidth" v-model.trim="scope.row.taxRatio" placeholder="请选择">
                  <el-option v-for="item in taxList" :key="item.id" :label="item.dictLabel" :value="item.dictValue"></el-option>
                </el-select>
								<!-- <input type="text" class="input_block" @blur="numberChange(scope.row,$event,'taxRatio')" :oninput="$root.numberFilter" :readonly="taxDisable" v-model.trim="scope.row.taxRatio" @input="autoCompute(scope.row)"> -->
							</div>
						</template>
					</el-table-column>
					<el-table-column label="含税单价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.unitAmountWithTax&&scope.row.unitAmountWithTax!==0&&!priceDisable}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'unitAmountWithTax')" :readonly="priceDisable"
								:oninput="$root.numberFilter6" v-model.trim="scope.row.unitAmountWithTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="不含税合价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'amountExclTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.amountExclTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="含税合价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'amountWithTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.amountWithTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="备注" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input type="text" class="input_block" :readonly="priceDisable" v-model.trim="scope.row.remarks">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
						<template slot-scope="scope">
							<el-button type="text" v-if="(scope.$index != 0 && scope.row.editable) || !validateFlag" size="mini" @click="del(scope.$index, 4)">
								<span style="color: #91002c">删除</span>
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-else-if="parentCodeType == $root.wyfw_category">
				<div v-if="codeType == $root.wyfwba_category || codeType == $root.wyfwbj_category">
					<div v-if="operationEnable">
						<el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData5">
							<i class="iconfont iconjiahaoyou"></i> 添加
						</el-button>
					</div>
					<el-table border key="tableData5" :max-height="maxHeight" :data="form.tableData5" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
						<el-table-column label="序号" type="index" fixed="left" width="100px">
							<template slot-scope="scope">
								<el-form-item>
									{{ scope.$index + 1 }}
								</el-form-item>
							</template>
						</el-table-column>
						<el-table-column label="报价类型" width="140px" fixed>
							<template slot-scope="scope">
								<span v-if="scope.row.quotationType == '2'">不计入合价</span>
								<span v-else>计入合价</span>
							</template>
						</el-table-column>
						<el-table-column label="标段" fixed width="140px" v-if="pageType != 'buyDemand' && type != 2">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.segmentsNumber&&!segmentDisable}">
									<el-select :disabled="segmentDisable || !scope.row.editable" size="mini" class="minWidth" v-model.trim="scope.row.segmentsNumber" placeholder="请选择">
										<el-option :key="1" :label="1" :value="1">
										</el-option>
										<el-option :key="2" :label="2" :value="2">
										</el-option>
									</el-select>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="分类索引" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.subitemName&&!basicInfoDisable}">
									<input type="text" class="input_block" :readonly="basicInfoDisable" v-model="scope.row.subitemName">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="岗位人员要求" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.matterName&&!basicInfoDisable}">
									<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.matterName">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="客用品/清洁用品/岗位用品需求" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.matterRequired&&!basicInfoDisable}">
									<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.matterRequired">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="单位" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.unitName&&!basicInfoDisable}">
									<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.unitName">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="岗位时间" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.postTime&&!basicInfoDisable}">
									<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.postTime" @input="autoCompute(scope.row)">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="服务时长(月)" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.serviceTime&&!basicInfoDisable}">
									<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.serviceTime">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="岗位数量" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.quantities&&scope.row.quantities!==0&&!basicInfoDisable}">
									<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'quantities')" :readonly="basicInfoDisable" :oninput="$root.numberFilter2" v-model.trim="scope.row.quantities">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="工时不含税单价（元/小时/岗）" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true}">
									<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'unitHourAmountExclTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.unitHourAmountExclTax">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="不含税单价（元）" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true}">
									<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'unitAmountExclTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.unitAmountExclTax" @input="autoCompute(scope.row)">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="税率（%）" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.taxRatio&&scope.row.taxRatio!==0&&!taxDisable}">
                  <el-select :disabled="taxDisable" size="mini" class="minWidth" v-model.trim="scope.row.taxRatio" placeholder="请选择">
                    <el-option v-for="item in taxList" :key="item.id" :label="item.dictLabel" :value="item.dictValue"></el-option>
                  </el-select>
									<!-- <input type="text" class="input_block" @blur="numberChange(scope.row,$event,'taxRatio')" :oninput="$root.numberFilter" :readonly="taxDisable" v-model.trim="scope.row.taxRatio" @input="autoCompute(scope.row)"> -->
								</div>
							</template>
						</el-table-column>
						<el-table-column label="含税单价（元）" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.unitAmountWithTax&&scope.row.unitAmountWithTax!==0&&!priceDisable}">
									<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'unitAmountWithTax')" :readonly="priceDisable"
									:oninput="$root.numberFilter6" v-model.trim="scope.row.unitAmountWithTax" @input="autoCompute(scope.row)">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="不含税合价（元）" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true}">
									<input type="text" class="input_block" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.amountExclTax" @input="autoCompute(scope.row)">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="含税合价（元）" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true}">
									<input type="text" class="input_block" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.amountWithTax" @input="autoCompute(scope.row)">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="备注" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true}">
									<input type="text" class="input_block" :readonly="priceDisable" v-model.trim="scope.row.remarks">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
							<template slot-scope="scope">
								<el-button type="text" v-if="(scope.$index != 0 && scope.row.editable) || !validateFlag" size="mini" @click="del(scope.$index, 5)">
									<span style="color: #91002c">删除</span>
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div v-else>
					<div v-if="operationEnable">
						<el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData6">
							<i class="iconfont iconjiahaoyou"></i> 添加
						</el-button>
					</div>
					<el-table border key="tableData6" :max-height="maxHeight" :data="form.tableData6" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
						<el-table-column label="序号" type="index" fixed="left" width="100px">
							<template slot-scope="scope">
								<el-form-item>
									{{ scope.$index + 1 }}
								</el-form-item>
							</template>
						</el-table-column>
						<el-table-column label="报价类型" width="140px" fixed>
							<template slot-scope="scope">
								<span v-if="scope.row.quotationType == '2'">不计入合价</span>
								<span v-else>计入合价</span>
							</template>
						</el-table-column>
						<el-table-column label="标段" fixed width="140px" v-if="pageType != 'buyDemand' && type != 2">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.segmentsNumber&&!segmentDisable}">
									<el-select :disabled="segmentDisable || !scope.row.editable" size="mini" class="minWidth" v-model.trim="scope.row.segmentsNumber" placeholder="请选择">
										<el-option :key="1" :label="1" :value="1">
										</el-option>
										<el-option :key="2" :label="2" :value="2">
										</el-option>
									</el-select>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="分类索引" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.subitemName&&!basicInfoDisable}">
									<input type="text" class="input_block" :readonly="basicInfoDisable" v-model="scope.row.subitemName">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="服务事项" width="140px">
							<template slot-scope="scope">

								<div :class="{input_box:true,error_box:!scope.row.matterName&&!basicInfoDisable}">
									<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.matterName">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="服务内容要求描述" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.matterRequired&&!basicInfoDisable}">
									<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.matterRequired">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="服务频次" width="140px">
							<template slot-scope="scope">
								<el-form-item :prop="'tableData6.' + scope.$index + '.maintenanceFrequency'" :rules='form.rules.maintenanceFrequency'>
									<el-input size="mini" :readonly="basicInfoDisable" v-model.trim="scope.row.maintenanceFrequency"></el-input>
								</el-form-item>
							</template>
						</el-table-column>
						<el-table-column label="设备/服务参数描述" width="140px">
							<template slot-scope="scope">
								<el-form-item :prop="'tableData6.' + scope.$index + '.matterDesc'" :rules='form.rules.matterDesc'>
									<el-input size="mini" :readonly="basicInfoDisable" v-model.trim="scope.row.matterDesc"></el-input>
								</el-form-item>
							</template>
						</el-table-column>
						<el-table-column label="服务周期（月）" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.serviceTime&&!basicInfoDisable}">
									<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.serviceTime">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="数量" width="140px">
							<template slot-scope="scope">

								<div :class="{input_box:true,error_box:!scope.row.quantities&&scope.row.quantities!==0&&!basicInfoDisable}">
									<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'quantities')" :readonly="basicInfoDisable" :oninput="$root.numberFilter2" v-model.trim="scope.row.quantities">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="单位" width="140px">
							<template slot-scope="scope">

								<div :class="{input_box:true,error_box:!scope.row.unitName&&!basicInfoDisable}">
									<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.unitName">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="不含税单价（元）" width="140px">
							<template slot-scope="scope">

								<div :class="{input_box:true}">
									<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'unitAmountExclTax')" readonly v-model.trim="scope.row.unitAmountExclTax" @input="autoCompute(scope.row)">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="税率/服务费率（%）" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.taxRatio&&scope.row.taxRatio!==0&&!taxDisable}">
									<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'taxRatio')" :oninput="$root.numberFilter" :readonly="taxDisable" v-model.trim="scope.row.taxRatio" @input="autoCompute(scope.row)">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="含税单价（元）" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true,error_box:!scope.row.unitAmountWithTax&&scope.row.unitAmountWithTax!==0&&!priceDisable}">
									<input type="text" class="input_block" :readonly="priceDisable" v-model.trim="scope.row.unitAmountWithTax"
									:oninput="$root.numberFilter6" @input="autoCompute(scope.row)">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="不含税合价（元）" width="140px">
							<template slot-scope="scope">

								<div :class="{input_box:true}">
									<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'amountExclTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.amountExclTax">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="含税合价（元）" width="140px">
							<template slot-scope="scope">
								<div :class="{input_box:true}">
									<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'amountWithTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.amountWithTax">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="备注" width="140px">
							<template slot-scope="scope">

								<div :class="{input_box:true}">
									<input type="text" class="input_block" :readonly="priceDisable" v-model.trim="scope.row.remarks">
								</div>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
							<template slot-scope="scope">
								<el-button type="text" v-if="(scope.$index != 0 && scope.row.editable) || !validateFlag" size="mini" @click="del(scope.$index, 6)">
									<span style="color: #91002c">删除</span>
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>

			<div v-else-if="parentCodeType == $root.wywb_category">
				<div v-if="operationEnable">
					<el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData7">
						<i class="iconfont iconjiahaoyou"></i> 添加
					</el-button>
				</div>
				<el-table border key="tableData7" :max-height="maxHeight" :data="form.tableData7" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
					<el-table-column label="序号" type="index" fixed="left" width="100px">
						<template slot-scope="scope">
							<el-form-item>
								{{ scope.$index + 1 }}
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="报价类型" width="140px" fixed>
						<template slot-scope="scope">
							<span v-if="scope.row.quotationType == '2'">不计入合价</span>
							<span v-else>计入合价</span>
						</template>
					</el-table-column>
					<el-table-column label="标段" fixed width="140px" v-if="pageType != 'buyDemand' && type != 2">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.segmentsNumber&&!segmentDisable}">
								<el-select :disabled="segmentDisable || !scope.row.editable" size="mini" class="minWidth" v-model.trim="scope.row.segmentsNumber" placeholder="请选择">
									<el-option :key="1" :label="1" :value="1">
									</el-option>
									<el-option :key="2" :label="2" :value="2">
									</el-option>
								</el-select>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="分类索引" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.subitemName&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model="scope.row.subitemName">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="维保事项" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.matterName&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.matterName">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="维保内容要求描述" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.matterRequired&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.matterRequired">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="维保频次" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.maintenanceFrequency&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.maintenanceFrequency">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="设备/服务参数描述" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.matterDesc&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.matterDesc">
							</div>
						</template>
					</el-table-column>
						<el-table-column label="维保周期（月）" width="140px">
								<template slot-scope="scope">
										<div :class="{input_box:true,error_box:!scope.row.serviceTime&&!basicInfoDisable}">
												<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'serviceTime')" :readonly="basicInfoDisable"
												:oninput="$root.numberFilter1" v-model="scope.row.serviceTime" @input="autoCompute(scope.row)">
										</div>
								</template>
						</el-table-column>
					<el-table-column label="数量" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.quantities&&scope.row.quantities!==0&&!basicInfoDisable}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'quantities')" :readonly="basicInfoDisable" :oninput="$root.numberFilter2" v-model.trim="scope.row.quantities">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="单位" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.unitName&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.unitName">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="不含税单价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'unitAmountExclTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.unitAmountExclTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="税率/服务费率（%）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.taxRatio&&scope.row.taxRatio!==0&&!taxDisable}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'taxRatio')" :oninput="$root.numberFilter" :readonly="taxDisable" v-model.trim="scope.row.taxRatio" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="含税单价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.unitAmountWithTax&&scope.row.unitAmountWithTax!==0&&!priceDisable}">
								<input type="text" class="input_block" :readonly="priceDisable" v-model.trim="scope.row.unitAmountWithTax"
								:oninput="$root.numberFilter6" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="不含税合价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'amountExclTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.amountExclTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="含税合价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'amountWithTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.amountWithTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="空调主机（冷量）" width="140px" v-if="this.codeType == $root.wywb_kt_category">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.conditionerHost&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.conditionerHost">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="高压柜/低压柜（KVA）" width="140px" v-if="this.codeType == $root.wywb_pds_category">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.highLowVoltage&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.highLowVoltage">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="备注" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input type="text" class="input_block" :readonly="priceDisable" v-model.trim="scope.row.remarks">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
						<template slot-scope="scope">
							<el-button type="text" v-if="(scope.$index != 0 && scope.row.editable) || !validateFlag" size="mini" @click="del(scope.$index, 7)">
								<span style="color: #91002c">删除</span>
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-else-if="parentCodeType == $root.sj_category">
				<div v-if="operationEnable">
					<el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData8">
						<i class="iconfont iconjiahaoyou"></i> 添加
					</el-button>
				</div>
				<el-table border key="tableData8" :max-height="maxHeight" :data="form.tableData8" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
					<el-table-column label="序号" type="index" fixed="left" width="100px">
						<template slot-scope="scope">
							<el-form-item>
								{{ scope.$index + 1 }}
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="报价类型" width="140px" fixed>
						<template slot-scope="scope">
							<span v-if="scope.row.quotationType == '2'">不计入合价</span>
							<span v-else>计入合价</span>
						</template>
					</el-table-column>
					<el-table-column label="标段" fixed width="140px" v-if="pageType != 'buyDemand' && type != 2">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.segmentsNumber&&!segmentDisable}">
								<el-select :disabled="segmentDisable || !scope.row.editable" size="mini" class="minWidth" v-model.trim="scope.row.segmentsNumber" placeholder="请选择">
									<el-option :key="1" :label="1" :value="1">
									</el-option>
									<el-option :key="2" :label="2" :value="2">
									</el-option>
								</el-select>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="设计阶段/设计内容/设计范围/设计深度/设计系统" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.matterName&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.matterName">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="数量" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.quantities&&scope.row.quantities!==0&&!basicInfoDisable}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'quantities')" :readonly="basicInfoDisable" :oninput="$root.numberFilter2" v-model.trim="scope.row.quantities">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="单位" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.unitName&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.unitName">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="设计面积（㎡）" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.designArea&&!basicInfoDisable}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'designArea')" :readonly="basicInfoDisable" :oninput="$root.numberFilter" v-model.trim="scope.row.designArea">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="不含税单价（元）" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'unitAmountExclTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.unitAmountExclTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="税率（%）" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.taxRatio&&scope.row.taxRatio!==0&&!taxDisable}">
                <el-select :disabled="taxDisable" size="mini" class="minWidth" v-model.trim="scope.row.taxRatio" placeholder="请选择">
                  <el-option v-for="item in taxList" :key="item.id" :label="item.dictLabel" :value="item.dictValue"></el-option>
                </el-select>
								<!-- <input type="text" class="input_block" @blur="numberChange(scope.row,$event,'taxRatio')" :oninput="$root.numberFilter" :readonly="taxDisable" v-model.trim="scope.row.taxRatio" @input="autoCompute(scope.row)"> -->
							</div>
						</template>
					</el-table-column>
					<el-table-column label="含税单价（元）" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.unitAmountWithTax&&scope.row.unitAmountWithTax!==0&&!priceDisable}">
								<input type="text" class="input_block" :readonly="priceDisable" v-model.trim="scope.row.unitAmountWithTax"
								:oninput="$root.numberFilter6" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="不含税合价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input type="text" class="input_block" readonly v-model.trim="scope.row.amountExclTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="含税合价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'amountWithTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.amountWithTax">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="备注" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input type="text" class="input_block" :readonly="priceDisable" v-model.trim="scope.row.remarks">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
						<template slot-scope="scope">
							<el-button type="text" v-if="(scope.$index != 0 && scope.row.editable) || !validateFlag" size="mini" @click="del(scope.$index, 8)">
								<span style="color: #91002c">删除</span>
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-else-if="parentCodeType == $root.gw_category">
				<div v-if="operationEnable">
					<el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData9">
						<i class="iconfont iconjiahaoyou"></i> 添加
					</el-button>
				</div>
				<el-table border key="tableData9" :max-height="maxHeight" :data="form.tableData9" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
					<el-table-column label="序号" type="index" fixed="left" width="100px">
						<template slot-scope="scope">
							<el-form-item>
								{{ scope.$index + 1 }}
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="报价类型" width="140px" fixed>
						<template slot-scope="scope">
							<span v-if="scope.row.quotationType == '2'">不计入合价</span>
							<span v-else>计入合价</span>
						</template>
					</el-table-column>
					<el-table-column label="标段" fixed width="140px" v-if="pageType != 'buyDemand' && type != 2">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.segmentsNumber&&!segmentDisable}">
								<el-select :disabled="segmentDisable || !scope.row.editable" size="mini" class="minWidth" v-model.trim="scope.row.segmentsNumber" placeholder="请选择">
									<el-option :key="1" :label="1" :value="1">
									</el-option>
									<el-option :key="2" :label="2" :value="2">
									</el-option>
								</el-select>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="顾问阶段/顾问服务内容/顾问范围/顾问系统/项目" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.matterName&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.matterName">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="数量" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.quantities&&scope.row.quantities!==0&&!basicInfoDisable}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'quantities')" :readonly="basicInfoDisable" :oninput="$root.numberFilter2" v-model.trim="scope.row.quantities">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="单位" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.unitName&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.unitName">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="不含税单价（元）" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true}">
								<input class="input_block" type="text" @blur="numberChange(scope.row,$event,'unitAmountExclTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.unitAmountExclTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="税率（%）" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.taxRatio&&scope.row.taxRatio!==0&&!taxDisable}">
                <el-select :disabled="taxDisable" size="mini" class="minWidth" v-model.trim="scope.row.taxRatio" placeholder="请选择">
                  <el-option v-for="item in taxList" :key="item.id" :label="item.dictLabel" :value="item.dictValue"></el-option>
                </el-select>
								<!-- <input class="input_block" type="text" @blur="numberChange(scope.row,$event,'taxRatio')" :oninput="$root.numberFilter" :readonly="taxDisable" v-model.trim="scope.row.taxRatio" @input="autoCompute(scope.row)"> -->
							</div>
						</template>
					</el-table-column>
					<el-table-column label="含税单价（元）/服务费率" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.unitAmountWithTax&&scope.row.unitAmountWithTax!==0&&!priceDisable}">
								<input type="text" class="input_block" :readonly="priceDisable"
								:oninput="$root.numberFilter3" v-model.trim="scope.row.unitAmountWithTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="不含税合价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input class="input_block" type="text" readonly v-model.trim="scope.row.amountExclTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="含税合价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input class="input_block" type="text" @blur="numberChange(scope.row,$event,'amountWithTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.amountWithTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="备注" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input type="text" class="input_block" :readonly="priceDisable" v-model.trim="scope.row.remarks">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
						<template slot-scope="scope">
							<el-button type="text" v-if="(scope.$index != 0 && scope.row.editable) || !validateFlag" size="mini" @click="del(scope.$index, 9)">
								<span style="color: #91002c">删除</span>
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-else-if="parentCodeType == $root.xx_category">
				<div v-if="operationEnable">
					<el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData10">
						<i class="iconfont iconjiahaoyou"></i> 添加
					</el-button>
				</div>
				<el-table :highlight-current-row="false" border key="tableData10" :max-height="maxHeight" :data="form.tableData10" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
					<el-table-column label="序号" type="index" fixed="left" width="100px">
						<template slot-scope="scope">
							<el-form-item>
								{{ scope.$index + 1 }}
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="报价类型" width="140px" fixed>
						<template slot-scope="scope">
							<span v-if="scope.row.quotationType == '2'">不计入合价</span>
							<span v-else>计入合价</span>
						</template>
					</el-table-column>
					<el-table-column label="标段" fixed width="140px" v-if="pageType != 'buyDemand' && type != 2">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.segmentsNumber&&!segmentDisable}">
								<el-select :disabled="segmentDisable || !scope.row.editable" size="mini" class="minWidth" v-model.trim="scope.row.segmentsNumber" placeholder="请选择">
									<el-option :key="1" :label="1" :value="1">
									</el-option>
									<el-option :key="2" :label="2" :value="2">
									</el-option>
								</el-select>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="招标事项" width="140px" fixed="left">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.matterName&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.matterName">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="招标需求内容描述/材质工艺等要求/服务内容" width="140px" fixed="left">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.matterRequired&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.matterRequired">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="规格型号尺寸/服务要求" width="140px">
						<template slot-scope="scope">
							<el-form-item :prop="'tableData10.' + scope.$index + '.specificationServiceRequirements'" :rules='form.rules.specificationServiceRequirements'>
								<el-input size="mini" :readonly="basicInfoDisable" v-model.trim="scope.row.specificationServiceRequirements"></el-input>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="投标推荐品牌" width="140px">
						<template slot-scope="scope">
							<el-form-item :prop="'tableData10.' + scope.$index + '.recommendBrand'" :rules='form.rules.recommendBrand'>
								<el-input size="mini" :readonly="basicInfoDisable" v-model.trim="scope.row.recommendBrand"></el-input>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="投标品牌" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.brandName&&!priceDisable}">
                                <input type="text" class="input_block" :readonly="priceDisable" size="mini" v-model="scope.row.brandName">
                            </div>
						</template>
					</el-table-column>
					<el-table-column label="数量" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.quantities&&scope.row.quantities!==0&&!basicInfoDisable}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'quantities')" :readonly="basicInfoDisable" :oninput="$root.numberFilter2" v-model.trim="scope.row.quantities">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="单位" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.unitName&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.unitName">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="不含税单价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input class="input_block" type="text" @blur="numberChange(scope.row,$event,'unitAmountExclTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.unitAmountExclTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="税率（%）" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.taxRatio&&scope.row.taxRatio!==0&&!taxDisable}">
                <el-select :disabled="taxDisable" size="mini" class="minWidth" v-model.trim="scope.row.taxRatio" placeholder="请选择">
                  <el-option v-for="item in taxList" :key="item.id" :label="item.dictLabel" :value="item.dictValue"></el-option>
                </el-select>
								<!-- <input class="input_block" type="text" @blur="numberChange(scope.row,$event,'taxRatio')" :oninput="$root.numberFilter" :readonly="taxDisable" v-model.trim="scope.row.taxRatio" @input="autoCompute(scope.row)"> -->
							</div>
						</template>
					</el-table-column>
					<el-table-column label="含税单价（元）" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.unitAmountWithTax&&scope.row.unitAmountWithTax!==0&&!priceDisable}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'unitAmountWithTax')" :readonly="priceDisable"
								:oninput="$root.numberFilter6" v-model.trim="scope.row.unitAmountWithTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="不含税合价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input class="input_block" type="text" @blur="numberChange(scope.row,$event,'amountExclTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.amountExclTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="含税合价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input class="input_block" type="text" @blur="numberChange(scope.row,$event,'amountWithTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.amountWithTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="备注" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input type="text" class="input_block" :readonly="priceDisable" v-model.trim="scope.row.remarks">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
						<template slot-scope="scope">
							<el-button type="text" v-if="(scope.$index != 0 && scope.row.editable) || !validateFlag" size="mini" @click="del(scope.$index, 10)">
								<span style="color: #91002c">删除</span>
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-else-if="parentCodeType == $root.xz_category">
				<div v-if="operationEnable">
					<el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData11">
						<i class="iconfont iconjiahaoyou"></i> 添加
					</el-button>
				</div>
				<el-table :highlight-current-row="false" :max-height="maxHeight" border key="tableData11" :data="form.tableData11" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
					<el-table-column label="序号" type="index" fixed="left" width="100px">
						<template slot-scope="scope">
							<el-form-item>
								{{ scope.$index + 1 }}
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="报价类型" width="140px" fixed>
						<template slot-scope="scope">
							<span v-if="scope.row.quotationType == '2'">不计入合价</span>
							<span v-else>计入合价</span>
						</template>
					</el-table-column>
					<el-table-column label="标段" fixed width="140px" v-if="pageType != 'buyDemand' && type != 2">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.segmentsNumber&&!segmentDisable}">
								<el-select :disabled="segmentDisable || !scope.row.editable" size="mini" class="minWidth" v-model.trim="scope.row.segmentsNumber" placeholder="请选择">
									<el-option :key="1" :label="1" :value="1">
									</el-option>
									<el-option :key="2" :label="2" :value="2">
									</el-option>
								</el-select>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="招标事项" width="140px" fixed="left">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.matterName&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.matterName">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="招标需求内容描述/材质工艺等要求" width="140px" fixed="left">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.matterRequired&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.matterRequired">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="规格型号尺寸" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.specificationServiceRequirements&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.specificationServiceRequirements">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="投标推荐品牌" width="140px">
						<template slot-scope="scope">
							<el-form-item :prop="'tableData11.' + scope.$index + '.recommendBrand'" :rules='form.rules.recommendBrand'>
								<el-input size="mini" :readonly="basicInfoDisable" v-model.trim="scope.row.recommendBrand"></el-input>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="投标品牌" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.brandName&&!priceDisable}">
                                <input type="text" class="input_block" :readonly="priceDisable" size="mini" v-model="scope.row.brandName">
                            </div>
						</template>
					</el-table-column>
					<el-table-column label="数量" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.quantities&&scope.row.quantities!==0&&!basicInfoDisable}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'quantities')" :readonly="basicInfoDisable" :oninput="$root.numberFilter2" v-model.trim="scope.row.quantities">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="单位" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.unitName&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.unitName">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="不含税单价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'unitAmountExclTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.unitAmountExclTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="税率（%）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.taxRatio&&scope.row.taxRatio!==0&&!taxDisable}">
                <el-select :disabled="taxDisable" size="mini" class="minWidth" v-model.trim="scope.row.taxRatio" placeholder="请选择">
                  <el-option v-for="item in taxList" :key="item.id" :label="item.dictLabel" :value="item.dictValue"></el-option>
                </el-select>
								<!-- <input class="input_block" type="text" @blur="numberChange(scope.row,$event,'taxRatio')" :oninput="$root.numberFilter" :readonly="taxDisable" v-model.trim="scope.row.taxRatio" @input="autoCompute(scope.row)"> -->
							</div>
						</template>
					</el-table-column>
					<el-table-column label="含税单价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.unitAmountWithTax&&scope.row.unitAmountWithTax!==0&&!priceDisable}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'unitAmountWithTax')" :readonly="priceDisable"
								:oninput="$root.numberFilter6" v-model.trim="scope.row.unitAmountWithTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="不含税合价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input class="input_block" type="text" @blur="numberChange(scope.row,$event,'amountExclTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.amountExclTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="含税合价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input class="input_block" type="text" @blur="numberChange(scope.row,$event,'amountWithTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.amountWithTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="备注" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input type="text" class="input_block" :readonly="priceDisable" v-model.trim="scope.row.remarks">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
						<template slot-scope="scope">
							<el-button type="text" v-if="(scope.$index != 0 && scope.row.editable) || !validateFlag" size="mini" @click="del(scope.$index, 11)">
								<span style="color: #91002c">删除</span>
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-else>
				<div v-if="operationEnable">
					<el-button type="primary" class="text-button f14" style="float: right;" @click.stop="addData12">
						<i class="iconfont iconjiahaoyou"></i> 添加
					</el-button>
				</div>
				<el-table :highlight-current-row="false" :max-height="maxHeight" border key="tableData12" :data="form.tableData12" :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
					<el-table-column label="序号" type="index" fixed="left" width="100px">
						<template slot-scope="scope">
							<el-form-item>
								{{ scope.$index + 1 }}
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="报价类型" width="140px" fixed>
						<template slot-scope="scope">
							<span v-if="scope.row.quotationType == '2'">不计入合价</span>
							<span v-else>计入合价</span>
						</template>
					</el-table-column>
					<el-table-column label="标段" fixed width="140px" v-if="pageType != 'buyDemand' && type != 2 && pageType != 'onlySupplier'">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.segmentsNumber&&!segmentDisable}">
								<el-select :disabled="segmentDisable || !scope.row.editable" size="mini" class="minWidth" v-model.trim="scope.row.segmentsNumber" placeholder="请选择">
									<el-option :key="1" :label="1" :value="1">
									</el-option>
									<el-option :key="2" :label="2" :value="2">
									</el-option>
								</el-select>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="招标事项" width="140px" fixed="left">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.matterName&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.matterName">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="招标需求内容描述/材质工艺等要求/品牌规格型号" width="140px" fixed="left">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.matterRequired&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.matterRequired">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="数量" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.quantities&&scope.row.quantities!==0&&!basicInfoDisable}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'quantities')" :readonly="basicInfoDisable" :oninput="$root.numberFilter2" v-model.trim="scope.row.quantities">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="单位" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.unitName&&!basicInfoDisable}">
								<input type="text" class="input_block" :readonly="basicInfoDisable" v-model.trim="scope.row.unitName">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="不含税单价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'unitAmountExclTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.unitAmountExclTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="税率（%）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true,error_box:!scope.row.taxRatio&&scope.row.taxRatio!==0&&!taxDisable}">
                <el-select :disabled="taxDisable" size="mini" class="minWidth" v-model.trim="scope.row.taxRatio" placeholder="请选择">
                  <el-option v-for="item in taxList" :key="item.id" :label="item.dictLabel" :value="item.dictValue"></el-option>
                </el-select>
								<!-- <input type="text" class="input_block" @blur="numberChange(scope.row,$event,'taxRatio')" :oninput="$root.numberFilter" :readonly="taxDisable" v-model.trim="scope.row.taxRatio" @input="autoCompute(scope.row)"> -->
							</div>
						</template>
					</el-table-column>
					<el-table-column label="含税单价（元）" width="140px">
						<template slot-scope="scope">
							<div :class="{input_box:true,error_box:!scope.row.unitAmountWithTax&&scope.row.unitAmountWithTax!==0&&!priceDisable}">
								<input type="text" class="input_block" @blur="numberChange(scope.row,$event,'unitAmountWithTax')" :readonly="priceDisable"
								:oninput="$root.numberFilter6" v-model.trim="scope.row.unitAmountWithTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="不含税合价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input class="input_block" type="text" @blur="numberChange(scope.row,$event,'amountExclTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.amountExclTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="含税合价（元）" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input class="input_block" type="text" @blur="numberChange(scope.row,$event,'amountWithTax')" readonly :oninput="$root.numberFilter" v-model.trim="scope.row.amountWithTax" @input="autoCompute(scope.row)">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="备注" width="140px">
						<template slot-scope="scope">

							<div :class="{input_box:true}">
								<input type="text" class="input_block" :readonly="priceDisable" v-model.trim="scope.row.remarks">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="100px" fixed="right" v-if="operationEnable">
						<template slot-scope="scope">
							<el-button v-if="(scope.$index != 0 && scope.row.editable) || !validateFlag" type="text" size="mini" @click="del(scope.$index, 12)">
								<span style="color: #91002c">
									<span style="color: #91002c">删除</span>
								</span>
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-form>
	</div>
</template>

<script>
import Vue from "vue";

export default Vue.component("inventory", {
  components: {},

  props: {
	code: {
	  type: String
	},
	parentCode: {
	  type: String
	},
	page: {
	  type: String
	},
	taxRatioFlag: {
	  type: Number
	},
	quotationFlag: {},
	segments: {
	  type: Number
	},
	readonly: {
	  type: Boolean
	},
	type: {
	  type: Number
	},
	maxHeight: {
	  type: Number,
	  default: 500
	},
	validateFlag: {
	  type: Boolean,
	  default: true
	}
  },
  computed: {
	priceDisable() {
	  return (
		this.pageType == "buyDemand" ||
		this.pageType == "bidOpen" ||
		this.pageType == "tenderListEdit"
	  );
	},
	basicInfoDisable() {
	  return this.pageType == "tenderEdit" || this.pageType == "bidBack";
	},
	taxDisable() {
	  if (this.pageType == "buyDemand" || this.pageType == "bidOpen") {
		return this.taxRatioMethod == "2";
	  } else {
		return this.taxRatioMethod == "1";
	  }
	},
	segmentDisable() {
	  return (
		this.segmentsNumber == 1 ||
		!this.segmentsNumber ||
		this.pageType == "tenderEdit"
	  );
	},
	operationEnable() {
	  return !this.readonly && this.priceDisable;
	}
  },
  watch: {
	code(val) {
	  this.codeType = val;
	},
	page(val) {
	  this.pageType = val;
	},
	taxRatioFlag(val) {
	  this.taxRatioMethod = val;
	  if (this.pageType == "buyDemand" || this.pageType == "bidOpen") {
		if (this.taxRatioMethod == 2) {
		  this.clearTaxRate();
		  delete this.form.rules.taxRatio;
		} else {
		  this.form.rules["taxRatio"] = this.formateRequiredRules([
			"taxRatio"
		  ]).taxRatio;
		}
	  } else {
		if (this.taxRatioMethod == 1) {
		  this.clearTaxRate();
		  delete this.form.rules.taxRatio;
		} else {
		  this.form.rules["taxRatio"] = this.formateRequiredRules([
			"taxRatio"
		  ]).taxRatio;
		}
	  }
	},
	quotationFlag(val) {
	  this.quotationMethod = val;
	},
	parentCode(val) {
	  this.parentCodeType = val;
	},
	segments(val) {
	  this.segmentsNumber = val;
	  if (this.segmentsNumber == 1) {
		this.resetSegmentNumber();
	  } else {
		if (this.pageType == "bidOpen") {
		  this.addSegmentTwo();
		}
	  }
	}
  },
  data() {
	return {
	  codeType: "",
	  parentCodeType: "",
	  pageType: "",
	  taxRatioMethod: "",
	  quotationMethod: "",
		segmentsNumber: "",
	  taxList: [],
	  form: {
		rules: {},
		tableData1: [
		  {
			quotationType: 1,
			subitemName: "",
			matterName: "",
			matterRequired: "",
			recommendBrand: "",
			brandName: "",
			constructArea: "",
			serviceRenovationArea: "",
			unitName: "",
			quantities: "",
			supplyUnitPrice: "",
			installUnitPrice: "",
			unitAmountExclTax: "",
			taxRatio: "",
			unitAmountWithTax: "",
			amountExclTax: "",
			amountWithTax: "",
			remarks: ""
		  }
		],
		tableData2: [
		  {
			quotationType: 1,
			subitemName: "",
			matterName: "",
			matterRequired: "",
			recommendBrand: "",
			brandName: "",
			constructArea: "",
			serviceRenovationArea: "",
			unitName: "",
			quantities: "",
			supplyUnitPrice: "",
			installUnitPrice: "",
			unitAmountExclTax: "",
			taxRatio: "",
			unitAmountWithTax: "",
			amountExclTax: "",
			amountWithTax: "",
			remarks: "",
			listPurpose: "2"
		  }
		],
		tableData3: [
		  {
			quotationType: 1,
			matterName: "",
			matterRequired: "",
			brandName: "",
			quantities: "",
			unitName: "",
			unitAmountExclTax: "",
			taxRatio: "",
			unitAmountWithTax: "",
			amountExclTax: "",
			amountWithTax: "",
			remarks: ""
		  }
		],
		tableData4: [
		  {
			quotationType: 1,
			matterName: "",
			matterRequired: "",
			areaLocations: "",

			matterDesc: "",
			speciificationSize: "",
			brandName: "",
			quantities: "",
			dayAmount: "",
			unitName: "",
			unitAmountExclTax: "",
			taxRatio: "",
			unitAmountWithTax: "",
			amountExclTax: "",
			amountWithTax: "",
			remarks: ""
		  }
		],
		tableData5: [
		  {
			quotationType: 1,
			subitemName: "",
			matterName: "",
			matterRequired: "",
			constructArea: "",
			unitName: "",
			quantities: "",
			postTime: "",
			serviceTime: "",
			unitHourAmountExclTax: "",
			unitAmountExclTax: "",
			taxRatio: "",
			unitAmountWithTax: "",
			monthlyAmountExclTax: "",
			monthlyAmountWithTax: "",
			yearlyAmountExclTax: "",
			yearlyAmountWithTax: "",
			amountExclTax: "",
			amountWithTax: "",
			remarks: "",
			hourlyUnitPrice: "",
			postPerConstructArea: ""
		  }
		],
		tableData6: [
		  {
			quotationType: 1,
			subitemName: "",
			matterName: "",
			matterRequired: "",
			maintenanceFrequency: "",
			matterDesc: "",
			quantities: "",
			unitName: "",
			unitAmountExclTax: "",
			taxRatio: "",
			unitAmountWithTax: "",
			amountExclTax: "",
			amountWithTax: "",
			conditionerHost: "",
			highLowVoltage: "",
			remarks: "",
			hourlyUnitPrice: "",
			postPerConstructArea: "",
			constructArea: "",
			unitPricePerSquare: ""
		  }
		],
		tableData7: [
		  {
			quotationType: 1,
			subitemName: "",
			matterName: "",
			matterRequired: "",
			maintenanceFrequency: "",
			matterDesc: "",
			quantities: "",
			unitName: "",
			unitAmountExclTax: "",
			taxRatio: "",
			unitAmountWithTax: "",
			amountExclTax: "",
			amountWithTax: "",
			conditionerHost: "",
			highLowVoltage: "",

			remarks: "",

			constructArea: "",
			unitPricePerSquare: ""
		  }
		],
		tableData8: [
		  {
			quotationType: 1,
			matterName: "",
			quantities: "",
			unitName: "",
			constructArea: "",
			designArea: "",
			unitAmountExclTax: "",
			taxRatio: "",
			unitAmountWithTax: "",
			amountExclTax: "",
			amountWithTax: "",
			remarks: ""
		  }
		],
		tableData9: [
		  {
			quotationType: 1,
			matterName: "",
			quantities: "",
			unitName: "",
			serviceFeeRatio: "",
			unitAmountExclTax: "",
			taxRatio: "",
			unitAmountWithTax: "",
			amountExclTax: "",
			amountWithTax: "",
			remarks: ""
		  }
		],
		tableData10: [
		  {
			quotationType: 1,
			matterName: "",
			matterRequired: "",
			quantities: "",
			brandName: "",
			specificationServiceRequirements: "",
			unitName: "",
			unitAmountExclTax: "",
			taxRatio: "",
			unitAmountWithTax: "",
			amountExclTax: "",
			amountWithTax: "",
			remarks: ""
		  }
		],
		tableData11: [
		  {
			quotationType: 1,
			matterName: "",
			matterRequired: "",
			quantities: "",
			brandName: "",
			specificationServiceRequirements: "",
			unitName: "",
			unitAmountExclTax: "",
			taxRatio: "",
			unitAmountWithTax: "",
			amountExclTax: "",
			amountWithTax: "",
			remarks: ""
		  }
		],
		tableData12: [
		  {
			quotationType: 1,
			matterName: "",
			matterRequired: "",
			quantities: "",
			unitName: "",
			unitAmountExclTax: "",
			taxRatio: "",
			unitAmountWithTax: "",
			amountExclTax: "",
			amountWithTax: "",
			remarks: ""
		  }
		]
	  }
	};
  },

  methods: {
	numberChange(row, e, fieldName) {
	  row[fieldName] = e.target.value;
	},
	autoCompute(row) {
	  if (!row.unitAmountWithTax || !row.taxRatio) {
            row.unitAmountExclTax = '';
            row.amountExclTax = '';
            row.amountWithTax = '';
            return;
        }
        let ratio = row.taxRatio;
        if (row.taxRatio >= 0) {
            ratio = this.$root.accDiv(parseFloat(row.taxRatio), 100);
				}
        let unitAmountExclTaxOld = parseFloat((parseFloat(row.unitAmountWithTax) / (1 + parseFloat(ratio))))
        row.unitAmountExclTax = unitAmountExclTaxOld.toFixed(6);
        if(row.postTime){
            // row.unitHourAmountExclTax = (unitAmountExclTaxOld / parseFloat(row.postTime) / 30).toFixed(2);
            //  工时单价元/小时=月岗位单价×12个月÷365天÷每日每岗出勤工时
            row.unitHourAmountExclTax = (unitAmountExclTaxOld * 12 / 365 / parseFloat(row.postTime)).toFixed(6);
        } else {
            row.unitHourAmountExclTax = '';
        }
        if (!row.quantities) {
            row.amountExclTax = '';
            row.amountWithTax = '';
            return;
				}
        let tempDayAmount = 1;
        if (row.dayAmount) {
            tempDayAmount = parseFloat(row.dayAmount);
        }
        let tempServiceTime = 1;
        if (row.serviceTime) {
            tempServiceTime = parseFloat(row.serviceTime);
        }
        let amountWithTaxOld = parseFloat(
            parseFloat(row.unitAmountWithTax) *
            parseFloat(row.quantities) *
            parseFloat(tempDayAmount) *
            parseFloat(tempServiceTime)
        );
        row.amountWithTax = amountWithTaxOld.toFixed(6);
		row.amountExclTax = this.$root.accDiv(amountWithTaxOld, 1 + parseFloat(ratio), 6).toFixed(6);
	},
	validate() {
	  if (this.parentCodeType == this.$root.gc_category) {
		return this.checkInventoryTableData1();
	  } else if (this.parentCodeType == this.$root.wzsb_category) {
		return this.checkInventoryTableData3();
	  } else if (this.parentCodeType == this.$root.yxtg_category) {
		return this.checkInventoryTableData4();
	  } else if (this.parentCodeType == this.$root.wyfw_category) {
		if (
		  this.codeType == this.$root.wyfwba_category ||
		  this.codeType == this.$root.wyfwbj_category
		) {
		  return this.checkInventoryTableData5();
		} else {
		  return this.checkInventoryTableData6();
		}
	  } else if (this.parentCodeType == this.$root.wywb_category) {
		return this.checkInventoryTableData7();
	  } else if (this.parentCodeType == this.$root.sj_category) {
		return this.checkInventoryTableData8();
	  } else if (this.parentCodeType == this.$root.gw_category) {
		return this.checkInventoryTableData9();
	  } else if (this.parentCodeType == this.$root.xx_category) {
		return this.checkInventoryTableData10();
	  } else if (this.parentCodeType == this.$root.xz_category) {
		return this.checkInventoryTableData11();
	  } else {
		return this.checkInventoryTableData12();
	  }
	},
	checkInventoryTableData1() {
	  return new Promise((resolve, reject) => {
		let list = this.getData();
		let str = list.some(item => {
		  if (!this.basicInfoDisable) {
			if (
			  !item.segmentsNumber ||
			  !item.matterName ||
			  !item.matterRequired ||
			  !item.recommendBrand ||
			  !item.unitName ||
			  !item.quantities
			) {
			  return true;
			}
		  }
		  if (!this.priceDisable) {
			if (
			  !item.unitAmountExclTax ||
			  !item.unitAmountWithTax ||
			  !item.amountExclTax ||
			  !item.amountWithTax
			) {
			  return true;
			}
		  }
		  if (!this.taxDisable) {
			if (!item.taxRatio) {
			  return true;
			}
		  }
		});
		str ? reject("请完成必填信息的填写！") : resolve(true);
	  });
	},
	checkInventoryTableData3() {
	  return new Promise((resolve, reject) => {
		let list = this.getData();
		let str = list.some(item => {
		  if (!this.basicInfoDisable) {
			if (
			  !item.segmentsNumber ||
			  !item.matterName ||
			  !item.matterRequired ||
			  !item.brandName ||
			  !item.unitName ||
			  !item.quantities
			) {
			  return true;
			}
		  }
		  if (!this.priceDisable) {
			if (this.pageType == "bidBack") {
			  if (this.emptyPrice(item.unitAmountExclTax)) {
				return true;
			  }
			} else {
			  if (
				!item.unitAmountExclTax ||
				!item.unitAmountWithTax ||
				!item.amountExclTax ||
				!item.amountWithTax
			  ) {
				return true;
			  }
			}
		  }
		  if (!this.taxDisable) {
			if (!item.taxRatio) {
			  return true;
			}
		  }
		});
		str ? reject("请完成必填信息的填写！") : resolve(true);
	  });
	},
	checkInventoryTableData4() {
	  return new Promise((resolve, reject) => {
		let list = this.getData();
		let str = list.some(item => {
		  if (!this.basicInfoDisable) {
			if (
			  !item.segmentsNumber ||
			  !item.matterRequired ||
			  !item.areaLocations ||
			  !item.matterDesc ||
			  !item.speciificationSize ||
			  !item.quantities ||
			  !item.dayAmount ||
			  !item.unitName
			) {
			  return true;
			}
		  }
		  if (!this.priceDisable) {
			if (this.pageType == "bidBack") {
			  if (this.emptyPrice(item.unitAmountExclTax)) {
				return true;
			  }
			} else {
			  if (
				!item.unitAmountExclTax ||
				!item.unitAmountWithTax ||
				!item.amountExclTax ||
				!item.amountWithTax
			  ) {
				return true;
			  }
			}
		  }
		  if (!this.taxDisable) {
			if (!item.taxRatio) {
			  return true;
			}
		  }
		});
		str ? reject("请完成必填信息的填写！") : resolve(true);
	  });
	},
	checkInventoryTableData5() {
	  return new Promise((resolve, reject) => {
		let list = this.getData();
		let str = list.some(item => {
		  if (!this.basicInfoDisable) {
			if (
			  !item.matterName ||
			  !item.matterRequired ||
			  !item.unitName ||
			  !item.quantities ||
			  !item.postTime ||
			  !item.serviceTime
			) {
			  return true;
			}
		  }
		  if (!this.priceDisable) {
			if (this.pageType == "bidBack") {
			  if (
				this.emptyPrice(item.unitAmountWithTax) ||
				this.emptyPrice(item.unitAmountExclTax)
			  ) {
				return true;
			  }
			} else {
			  if (
				!item.unitAmountExclTax ||
				!item.unitAmountWithTax
			  ) {
				return true;
			  }
			}
		  }
		  if (!this.taxDisable) {
			if (!item.taxRatio || item.taxRatio === "") {
			  return true;
			}
		  }
		});
		str ? reject("请完成必填信息的填写！") : resolve(true);
	  });
	},
	checkInventoryTableData6() {
	  return new Promise((resolve, reject) => {
		let list = this.getData();
		let str = list.some(item => {
		  if (!this.basicInfoDisable) {
			if (
			  !item.matterName ||
			  !item.matterRequired ||
			  !item.maintenanceFrequency ||
			  !item.matterDesc ||
			  !item.quantities ||
			  !item.unitName ||
			  !item.serviceTime
			) {
			  return true;
			}
		  }
		  if (!this.priceDisable) {
			if (this.pageType == "bidBack") {
			  if (
				this.emptyPrice(item.unitAmountExclTax) ||
				this.emptyPrice(item.unitAmountWithTax)
			  ) {
				return true;
			  }
			} else {
			  if (
				!item.unitAmountExclTax ||
				!item.unitAmountWithTax ||
				!item.amountExclTax ||
				!item.amountWithTax
			  ) {
				return true;
			  }
			}
		  }
		  if (!this.taxDisable) {
			if (!item.taxRatio || item.taxRatio === "") {
			  return true;
			}
		  }
		});
		str ? reject("请完成必填信息的填写！") : resolve(true);
	  });
	},
	checkInventoryTableData7() {
	  return new Promise((resolve, reject) => {
		let list = this.getData();
		let str = list.some(item => {
		  if (!this.basicInfoDisable) {
			if (
			  !item.matterName ||
			  !item.matterRequired ||
			  !item.maintenanceFrequency ||
			  !item.matterDesc ||
			  !item.quantities ||
			  !item.unitName ||
              !item.serviceTime
			) {
			  return true;
			}
		  }
		  if (!this.priceDisable) {
			if (this.pageType == "bidBack") {
			  if (
				this.emptyPrice(item.unitAmountExclTax) ||
				this.emptyPrice(item.unitAmountWithTax)
			  ) {
				return true;
			  }
			} else {
			  if (
				!item.unitAmountExclTax ||
				!item.unitAmountWithTax ||
				!item.amountExclTax ||
				!item.amountWithTax
			  ) {
				return true;
			  }
			}
		  }
		  if (!this.taxDisable) {
			if (!item.taxRatio) {
			  return true;
			}
		  }
		});
		str ? reject("请完成必填信息的填写！") : resolve(true);
	  });
	},
	checkInventoryTableData8() {
	  return new Promise((resolve, reject) => {
		let list = this.getData();
		let str = list.some(item => {
		  if (!this.basicInfoDisable) {
			if (
			  !item.matterName ||
			  !item.quantities ||
			  !item.unitName ||
			  !item.designArea
			) {
			  return true;
			}
		  }
		  if (!this.priceDisable) {
			if (this.pageType == "bidBack") {
			  if (
				this.emptyPrice(item.unitAmountExclTax) ||
				this.emptyPrice(item.unitAmountWithTax)
			  ) {
				return true;
			  }
			} else {
			  if (
				!item.unitAmountExclTax ||
				!item.unitAmountWithTax ||
				!item.amountExclTax ||
				!item.amountWithTax
			  ) {
				return true;
			  }
			}
		  }
		  if (!this.taxDisable) {
			if (!item.taxRatio) {
			  return true;
			}
		  }
		});
		str ? reject("请完成必填信息的填写！") : resolve(true);
	  });
	},
	checkInventoryTableData9() {
	  return new Promise((resolve, reject) => {
		let list = this.getData();
		let str = list.some(item => {
		  if (!this.basicInfoDisable) {
			if (
			  !item.matterName ||
			  !item.quantities ||
			  !item.unitName
			) {
			  return true;
			}
		  }
		  if (!this.priceDisable) {
			if (this.pageType == "bidBack") {
			  if (
				this.emptyPrice(item.unitAmountExclTax) ||
				this.emptyPrice(item.unitAmountWithTax)
			  ) {
				return true;
			  }
			} else {
			  if (
				!item.unitAmountExclTax ||
				!item.unitAmountWithTax ||
				!item.amountExclTax ||
				!item.amountWithTax
			  ) {
				return true;
			  }
			}
		  }
		  if (!this.taxDisable) {
			if (!item.taxRatio) {
			  return true;
			}
		  }
		});
		str ? reject("请完成必填信息的填写！") : resolve(true);
	  });
	},
	checkInventoryTableData10() {
	  return new Promise((resolve, reject) => {
		let list = this.getData();
		let str = list.some(item => {
		  if (!this.basicInfoDisable) {
			if (
			  !item.matterName ||
			  !item.matterRequired ||
			  !item.brandName ||
			  !item.specificationServiceRequirements ||
			  !item.quantities ||
			  !item.unitName
			) {
			  return true;
			}
		  }
		  if (!this.priceDisable) {
			if (this.pageType == "bidBack") {
			  if (
				this.emptyPrice(item.unitAmountExclTax) ||
				this.emptyPrice(item.unitAmountWithTax)
			  ) {
				return true;
			  }
			} else {
			  if (
				!item.unitAmountExclTax ||
				!item.unitAmountWithTax ||
				!item.amountExclTax ||
				!item.amountWithTax
			  ) {
				return true;
			  }
			}
		  }
		  if (!this.taxDisable) {
			if (!item.taxRatio) {
			  return true;
			}
		  }
		});
		str ? reject("请完成必填信息的填写！") : resolve(true);
	  });
	},
	checkInventoryTableData11() {
	  return new Promise((resolve, reject) => {
		let list = this.getData();
		let str = list.some(item => {
		  if (!this.basicInfoDisable) {
			if (
			  !item.matterName ||
			  !item.matterRequired ||
			  !item.brandName ||
			  !item.specificationServiceRequirements ||
			  !item.quantities ||
			  !item.unitName
			) {
			  return true;
			}
		  }
		  if (!this.priceDisable) {
			if (this.pageType == "bidBack") {
			  if (
				this.emptyPrice(item.unitAmountExclTax) ||
				this.emptyPrice(item.unitAmountWithTax)
			  ) {
				return true;
			  }
			} else {
			  if (
				!item.unitAmountExclTax ||
				!item.unitAmountWithTax ||
				!item.amountExclTax ||
				!item.amountWithTax
			  ) {
				return true;
			  }
			}
		  }
		  if (!this.taxDisable) {
			if (!item.taxRatio) {
			  return true;
			}
		  }
		});
		str ? reject("请完成必填信息的填写！") : resolve(true);
	  });
	},
	checkInventoryTableData12() {
	  return new Promise((resolve, reject) => {
		let list = this.getData();
		let str = list.some(item => {
		  if (!this.basicInfoDisable) {
			if (
			  !item.matterName ||
			  !item.matterRequired ||
			  !item.quantities ||
			  !item.unitName
			) {
			  return true;
			}
		  }
		  if (!this.priceDisable) {
			if (this.pageType == "bidBack") {
			  if (
				this.emptyPrice(item.unitAmountExclTax) ||
				this.emptyPrice(item.unitAmountWithTax)
			  ) {
				return true;
			  }
			} else {
			  if (
				!item.unitAmountExclTax ||
				!item.unitAmountWithTax ||
				!item.amountExclTax ||
				!item.amountWithTax
			  ) {
				return true;
			  }
			}
		  }
		  if (!this.taxDisable) {
			if (!item.taxRatio) {
			  return true;
			}
		  }
		});
		str ? reject("请完成必填信息的填写！") : resolve(true);
	  });
	},
	emptyPrice(val) {
	  return val === "" || !val;
	},
	clearValidate() {
	  this.$nextTick(() => {
		this.$refs["form"].clearValidate();
	  });
	},
	resetForm() {
	  this.$refs["form"].resetFields();
	},
	setData(list1, obj) {
	  list1 = list1 || [];
	  this.parentCodeType = obj.parentCategoryCode;
	  this.codeType = obj.categoryCode;
	  this.taxRatioMethod = obj.taxRatioMethod;
	  this.quotationMethod = obj.quotationMethod;
		this.$root.getHttp('/v1/sysDict/public/getDictListByDictType?dictType='+'flow_form_tax_config', (res) => {
      console.log(res.data)
      this.taxList = res.data.data
		});
	  list1.forEach(item => {
		if (!item.segmentsNumber) {
		  item.segmentsNumber = 1;
		}
		Object.keys(item).forEach(p => {
		  if (item[p] === 0) {
			item[p] = "0";
		  }
		});

		// 清单数量、金额小数点控制
        if (item.quantities && item.quantities != 0)
          item.quantities = parseFloat(item.quantities).toFixed(3);
        if (item.unitAmountExclTax && item.unitAmountExclTax != 0)
          item.unitAmountExclTax = parseFloat(item.unitAmountExclTax).toFixed(2);
        if (item.amountExclTax && item.amountExclTax != 0)
          item.amountExclTax = parseFloat(item.amountExclTax).toFixed(2);
        if (item.amountWithTax && item.amountWithTax != 0)
          item.amountWithTax = parseFloat(item.amountWithTax).toFixed(2);

        if (this.parentCodeType == this.$root.gw_category) {
          if (item.unitAmountWithTax && item.unitAmountWithTax != 0)
            item.unitAmountWithTax = parseFloat(item.unitAmountWithTax).toFixed(4);
        } else {
          if (item.unitAmountWithTax && item.unitAmountWithTax != 0)
            item.unitAmountWithTax = parseFloat(item.unitAmountWithTax).toFixed(2);
        }
	  });

	  if (this.parentCodeType == this.$root.gc_category) {
		this.form.tableData1 = list1;
	  } else if (this.parentCodeType == this.$root.wzsb_category) {
		this.form.tableData3 = list1;
	  } else if (this.parentCodeType == this.$root.yxtg_category) {
		this.form.tableData4 = list1;
	  } else if (this.parentCodeType == this.$root.wyfw_category) {
		if (
		  this.codeType == this.$root.wyfwba_category ||
		  this.codeType == this.$root.wyfwbj_category
		) {
		  this.form.tableData5 = list1;
		} else {
		  this.form.tableData6 = list1;
		}
	  } else if (this.parentCodeType == this.$root.wywb_category) {
		this.form.tableData7 = list1;
	  } else if (this.parentCodeType == this.$root.sj_category) {
		this.form.tableData8 = list1;
	  } else if (this.parentCodeType == this.$root.gw_category) {
		this.form.tableData9 = list1;
	  } else if (this.parentCodeType == this.$root.xx_category) {
		this.form.tableData10 = list1;
	  } else if (this.parentCodeType == this.$root.xz_category) {
		this.form.tableData11 = list1;
	  } else {
		this.form.tableData12 = list1;
	  }
	},
	getData() {
	  if (this.parentCodeType == this.$root.gc_category) {
		return this.form.tableData1;
	  } else if (this.parentCodeType == this.$root.wzsb_category) {
		return this.form.tableData3;
	  } else if (this.parentCodeType == this.$root.yxtg_category) {
		return this.form.tableData4;
	  } else if (this.parentCodeType == this.$root.wyfw_category) {
		if (
		  this.codeType == this.$root.wyfwba_category ||
		  this.codeType == this.$root.wyfwbj_category
		) {
		  return this.form.tableData5;
		} else {
		  return this.form.tableData6;
		}
	  } else if (this.parentCodeType == this.$root.wywb_category) {
		return this.form.tableData7;
	  } else if (this.parentCodeType == this.$root.sj_category) {
		return this.form.tableData8;
	  } else if (this.parentCodeType == this.$root.gw_category) {
		return this.form.tableData9;
	  } else if (this.parentCodeType == this.$root.xx_category) {
		return this.form.tableData10;
	  } else if (this.parentCodeType == this.$root.xz_category) {
		return this.form.tableData11;
	  } else {
		return this.form.tableData12;
	  }
	},
	submitFormFnc(formName) {
	  let that = this;
	  var f = function() {
		const p = new Promise((resolve, reject) => {
		  let form = that.$refs[formName];
		  if (Array.isArray(that.$refs[formName])) {
			form = that.$refs[formName][0];
		  }
		  form.validate(valid => {
			if (valid) {
			  resolve(true);
			} else {
			  reject("请正确填写清单必填信息！");
			}
		  });
		});
		return p;
	  };
	  return f;
	},
	submitFormPromise(formName) {
	  return this.submitFormFnc(formName)();
	},
	addSegmentTwo() {
	  this.addData1(false, 2);

	  this.addData3(false, 2);
	  this.addData4(false, 2);
	  this.addData5(false, 2);
	  this.addData6(false, 2);
	  this.addData7(false, 2);
	  this.addData8(false, 2);
	  this.addData9(false, 2);
	  this.addData10(false, 2);
	  this.addData11(false, 2);
	  this.addData12(false, 2);
	},
	resetSegmentNumber() {
	  this.resetTableSegmentNumber("tableData1");

	  this.resetTableSegmentNumber("tableData3");
	  this.resetTableSegmentNumber("tableData4");
	  this.resetTableSegmentNumber("tableData5");
	  this.resetTableSegmentNumber("tableData6");
	  this.resetTableSegmentNumber("tableData7");
	  this.resetTableSegmentNumber("tableData8");
	  this.resetTableSegmentNumber("tableData9");
	  this.resetTableSegmentNumber("tableData10");
	  this.resetTableSegmentNumber("tableData11");
	  this.resetTableSegmentNumber("tableData12");
	},
	resetTableSegmentNumber(tableName) {
	  this.form[tableName] = this.form[tableName].filter(item => {
		return item.segmentsNumber == 1;
	  });
	  this.form[tableName].forEach(row => {
		row.segmentsNumber = 1;
	  });
	},

	clearTableTaxRate(tableName) {
	  this.form[tableName].forEach(row => {
		row.taxRatio = "";
	  });
	},
	clearTaxRate() {
	  this.clearTableTaxRate("tableData1");
	  this.clearTableTaxRate("tableData2");
	  this.clearTableTaxRate("tableData3");
	  this.clearTableTaxRate("tableData4");
	  this.clearTableTaxRate("tableData5");
	  this.clearTableTaxRate("tableData6");
	  this.clearTableTaxRate("tableData7");
	  this.clearTableTaxRate("tableData8");
	  this.clearTableTaxRate("tableData9");
	  this.clearTableTaxRate("tableData10");
	  this.clearTableTaxRate("tableData11");
	  this.clearTableTaxRate("tableData12");
	},
	formateRequiredRules(attrs) {
	  let rules = {};
	  let numberAttrs = [
		"constructArea",
		"serviceRenovationArea",
		"quantities",
		"postPerConstructArea",
		"designArea",
		"supplyUnitPrice",
		"installUnitPrice",
		"unitAmountExclTax",
		"unitAmountWithTax",
		"amountExclTax",
		"amountWithTax",
		"unitHourAmountExclTax",
		"monthlyAmountExclTax",
		"monthlyAmountWithTax",
		"yearlyAmountExclTax",
		"yearlyAmountWithTax",
		"hourlyUnitPrice",
		"unitPricePerSquare",
		"taxRatio",
		'serviceTime',
	  ];

	  attrs.forEach((name, index) => {
		rules[name] = [
		  {
			required: true,
			message: "请输入",
			trigger: "blur"
		  }
		];
		if (numberAttrs.indexOf(name) != -1) {
		  rules[name].push({
			pattern: /(^[0-9]+$)|(^[0-9]+[\.]{1}[0-9]{1,2}$)/g,
			message: "必须为有效数值",
			trigger: "blur"
		  });
		}
	  });
	  return rules;
	},
	del(index, type) {
	  this.form["tableData" + type].splice(index, 1);
	},
	addData1(editable = true, segmentsNumber = 1) {
	  var item = {
		quotationType: 1,
		segmentsNumber: segmentsNumber,
		subitemName: "",
		matterName: "",
		matterRequired: "",
		recommendBrand: "",
		brandName: "",
		constructArea: "",
		serviceRenovationArea: "",
		unitName: "",
		quantities: "",
		supplyUnitPrice: "",
		installUnitPrice: "",
		unitAmountExclTax: "",
		taxRatio: "",
		unitAmountWithTax: "",
		amountExclTax: "",
		amountWithTax: "",
		remarks: "",
		editable: editable
	  };
	  this.form.tableData1.push(item);
	},
	addData2(editable = true, segmentsNumber = 1) {
	  var item = {
		quotationType: 1,
		segmentsNumber: segmentsNumber,
		subitemName: "",
		matterName: "",
		matterRequired: "",
		recommendBrand: "",
		brandName: "",
		constructArea: "",
		serviceRenovationArea: "",
		unitName: "",
		quantities: "",
		supplyUnitPrice: "",
		installUnitPrice: "",
		unitAmountExclTax: "",
		taxRatio: "",
		unitAmountWithTax: "",
		amountExclTax: "",
		amountWithTax: "",
		remarks: "",
		listPurpose: "2",
		editable: editable
	  };
	  this.form.tableData2.push(item);
	},
	addData3(editable = true, segmentsNumber = 1) {
	  var item = {
		quotationType: 1,
		segmentsNumber: segmentsNumber,
		matterName: "",
		matterRequired: "",

		brandName: "",
		quantities: "",
		unitName: "",
		unitAmountExclTax: "",
		taxRatio: "",
		unitAmountWithTax: "",
		amountExclTax: "",
		amountWithTax: "",
		remarks: "",
		editable: editable
	  };
	  this.form.tableData3.push(item);
	},
	addData4(editable = true, segmentsNumber = 1) {
	  var item = {
		quotationType: 1,
		segmentsNumber: segmentsNumber,
		matterName: "",
		matterRequired: "",
		areaLocations: "",

		matterDesc: "",
		speciificationSize: "",
		brandName: "",
		quantities: "",
		dayAmount: "",
		unitName: "",
		unitAmountExclTax: "",
		taxRatio: "",
		unitAmountWithTax: "",
		amountExclTax: "",
		amountWithTax: "",
		remarks: "",
		editable: editable
	  };
	  this.form.tableData4.push(item);
	},
	addData5(editable = true, segmentsNumber = 1) {
	  var item = {
		quotationType: 1,
		subitemName: "",
		segmentsNumber: segmentsNumber,
		matterName: "",
		matterRequired: "",
		constructArea: "",
		unitName: "",
		quantities: "",
		postTime: "",
		unitHourAmountExclTax: "",
		unitAmountExclTax: "",
		taxRatio: "",
		unitAmountWithTax: "",
		monthlyAmountExclTax: "",
		monthlyAmountWithTax: "",
		yearlyAmountExclTax: "",
		yearlyAmountWithTax: "",
		remarks: "",
		hourlyUnitPrice: "",
		postPerConstructArea: "",
		editable: editable
	  };
	  this.form.tableData5.push(item);
	},
	addData6(editable = true, segmentsNumber = 1) {
	  var item = {
		quotationType: 1,
		subitemName: "",
		segmentsNumber: segmentsNumber,
		matterName: "",
		matterRequired: "",
		maintenanceFrequency: "",
		matterDesc: "",
		quantities: "",
		unitName: "",
		unitAmountExclTax: "",
		taxRatio: "",
		unitAmountWithTax: "",
		amountExclTax: "",
		amountWithTax: "",
		conditionerHost: "",
		highLowVoltage: "",

		remarks: "",
		hourlyUnitPrice: "",
		postPerConstructArea: "",
		constructArea: "",
		unitPricePerSquare: "",
		editable: editable
	  };
	  this.form.tableData6.push(item);
	},
	addData7(editable = true, segmentsNumber = 1) {
	  var item = {
		quotationType: 1,
		subitemName: "",
		segmentsNumber: segmentsNumber,
		matterName: "",
		matterRequired: "",
		maintenanceFrequency: "",
		matterDesc: "",
		quantities: "",
		unitName: "",
		unitAmountExclTax: "",
		taxRatio: "",
		unitAmountWithTax: "",
		amountExclTax: "",
		amountWithTax: "",
		conditionerHost: "",
		highLowVoltage: "",

		remarks: "",

		constructArea: "",
		unitPricePerSquare: "",
		editable: editable
	  };
	  this.form.tableData7.push(item);
	},
	addData8(editable = true, segmentsNumber = 1) {
	  var item = {
		quotationType: 1,
		segmentsNumber: segmentsNumber,
		matterName: "",
		quantities: "",
		unitName: "",
		constructArea: "",
		designArea: "",
		unitAmountExclTax: "",
		taxRatio: "",
		unitAmountWithTax: "",
		amountExclTax: "",
		amountWithTax: "",
		remarks: "",
		editable: editable
	  };
	  this.form.tableData8.push(item);
	},
	addData9(editable = true, segmentsNumber = 1) {
	  var item = {
		quotationType: 1,
		segmentsNumber: segmentsNumber,
		matterName: "",
		quantities: "",
		unitName: "",
		serviceFeeRatio: "",
		unitAmountExclTax: "",
		taxRatio: "",
		unitAmountWithTax: "",
		amountExclTax: "",
		amountWithTax: "",
		remarks: "",
		editable: editable
	  };
	  this.form.tableData9.push(item);
	},
	addData10(editable = true, segmentsNumber = 1) {
	  var item = {
		quotationType: 1,
		segmentsNumber: segmentsNumber,
		matterName: "",
		matterRequired: "",
		quantities: "",
		brandName: "",
		specificationServiceRequirements: "",
		unitName: "",
		unitAmountExclTax: "",
		taxRatio: "",
		unitAmountWithTax: "",
		amountExclTax: "",
		amountWithTax: "",
		remarks: "",
		editable: editable
	  };
	  this.form.tableData10.push(item);
	},
	addData11(editable = true, segmentsNumber = 1) {
	  var item = {
		quotationType: 1,
		segmentsNumber: segmentsNumber,
		matterName: "",
		matterRequired: "",
		quantities: "",
		brandName: "",
		specificationServiceRequirements: "",
		unitName: "",
		unitAmountExclTax: "",
		taxRatio: "",
		unitAmountWithTax: "",
		amountExclTax: "",
		amountWithTax: "",
		remarks: "",
		editable: editable
	  };
	  this.form.tableData11.push(item);
	},
	addData12(editable = true, segmentsNumber = 1) {
	  var item = {
		quotationType: 1,
		segmentsNumber: segmentsNumber,
		matterName: "",
		matterRequired: "",
		quantities: "",
		unitName: "",
		unitAmountExclTax: "",
		taxRatio: "",
		unitAmountWithTax: "",
		amountExclTax: "",
		amountWithTax: "",
		remarks: "",
		editable: editable
	  };
	  this.form.tableData12.push(item);
	}
  },

  created() {
	this.quotationMethod = this.quotationFlag;
	this.taxRatioMethod = this.taxRatioFlag;
	this.pageType = this.page;
	this.codeType = this.code;
	this.parentCodeType = this.parentCode;
	this.segmentsNumber = this.segments;
  },

  mounted() {
	this.form.rules = this.formateRequiredRules([
	  "subitemName",
	  "matterName",
	  "matterRequired",
	  "recommendBrand",
	  "brandName",
	  "constructArea",
	  "serviceRenovationArea",
	  "unitName",
	  "quantities",
	  "areaLocations",
	  "matterDesc",
	  "postTime",
	  "serviceTime",
	  "postPerConstructArea",
	  "maintenanceFrequency",
	  "conditionerHost",
	  "highLowVoltage",
	  "designArea",
		"specificationServiceRequirements",
		'serviceTime'
	]);

	if (this.pageType == "tenderEdit" || this.pageType == "bidBack") {
	  this.form.rules = this.formateRequiredRules([
		"brandName",
		"constructArea",
		"serviceRenovationArea",
		"unitName",
		"quantities",
		"areaLocations",
		"matterDesc",
		"postTime",
		"serviceTime",
		"postPerConstructArea",
		"maintenanceFrequency",
		"conditionerHost",
		"highLowVoltage",
		"designArea",
		"specificationServiceRequirements",
		"supplyUnitPrice",
		"installUnitPrice",
		"unitAmountExclTax",
		"unitAmountWithTax",
		"amountExclTax",
		"amountWithTax",
		"unitHourAmountExclTax",
		"monthlyAmountExclTax",
		"monthlyAmountWithTax",
		"yearlyAmountExclTax",
		"yearlyAmountWithTax",
		"hourlyUnitPrice",
		"unitPricePerSquare",
		'serviceTime'
	  ]);
	}
	if (this.pageType == "bidBack") {
	  delete this.form.rules.remarks;
	}
	if (!this.validateFlag) {
	  this.form.tableData1 = [];
	  this.form.tableData2 = [];
	  this.form.tableData3 = [];
	  this.form.tableData4 = [];
	  this.form.tableData5 = [];
	  this.form.tableData6 = [];
	  this.form.tableData7 = [];
	  this.form.tableData8 = [];
	  this.form.tableData9 = [];
	  this.form.tableData10 = [];
	  this.form.tableData11 = [];
	  this.form.tableData12 = [];
	}
  }
});
</script>

<style lang='scss' scoped>
@import "../../../assets/_var.scss";

.inventory /deep/ {
  margin-top: -15px;

  .el-input__inner {
	border: none !important;
	border-bottom: none !important;
	border-radius: 0 !important;
	background-color: transparent !important;
	display: block;
	width: 100%;
	box-sizing: border-box;
	line-height: 33px;
	height: 33px;
	padding: 0 10px;
  }

  .el-form-item {
	margin-bottom: 0px;
  }

  .el-form-item.is-error .el-input__inner {
	border-color: #f56c6c !important;
  }

  .text-button.el-button {
	font-size: 16px;
	text-align: left;
	color: #333333;
	line-height: 21px;
	background: white;
	border: none;
  }

  .el-form-item__content {
	line-height: 34px;
  }

  .el-table--mini th,
  .el-table--mini td {
	padding: 0px;
  }
}

.el-table td .cell {
  padding: 0;
}

/deep/ .inventory .el-input__inner {
  border: none !important;
}

.el-form-item.is-error {
  border: 1px solid #dd2727;
  position: absolute;
  left: -1px;
  right: 0px;
  top: -1px;
  width: calc(100% + 2px);
  background-color: #fff;
}

.el-table__body tr:first-child .el-form-item.is-error {
  top: 0px;
}

.el-table__body tr td:nth-child(2) .el-form-item.is-error {
  left: 0px;
}

.container .el-form-item__error {
  display: none;
}

/deep/ .el-table__body tr.hover-row > td {
  background-color: #ecf5ff !important;
}

/deep/ .el-table__body tr.hover-row > td {
  background-color: transparent;
}

.input_box {
  position: absolute;
  left: -1px;
  right: -1px;
  top: -1px;
  bottom: -1px;
}

.el-table__body tr:last-child .input_box.error_box {
  bottom: 1px;
}

.input_box.error_box {
  border: 1px solid #dd2727;
}

.input_block {
  display: block;
  width: 100%;
  box-sizing: border-box;
  border: none;
  line-height: 33px;
  height: 33px;
  padding: 0 10px;
  background-color: transparent;
}

.input_block:focus {
  outline: none;
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/bid/components/inventory.vue